import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ChecklistItemViewModel } from 'src/app/modules/shared/models/checklists/checklistItemViewModel';
import { UtilitiesService } from 'src/app/modules/shared/services/utilities.service';
import { T } from 'src/assets/i18n/translation-keys';
import { ChecklistHelperService } from '../services/checklist-helper-service.service';


@Component({
    selector: 'app-checklist-summary',
    templateUrl: './checklist-summary.component.html',
    styleUrl: './checklist-summary.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ChecklistSummaryComponent implements OnInit, OnChanges {
  @Input() checklistItems: ChecklistItemViewModel[] = [];
  @Input() isExpandedAll: boolean;
  @Input() showExpandBtn: boolean = true;

  @Output() toggleExpand = new EventEmitter<number>();

  public readonly T = T;
  public percentageComplete: number = 0;
  public incompleteCount: number = 0;
  public completeCount: number = 0;
  public failedOrPoorCount: number = 0;
  public unsureOrFairCount: number = 0;

  constructor(
    private readonly utilitiesService: UtilitiesService,
    private readonly checklistHelperService: ChecklistHelperService
  ) {}

  ngOnInit(): void {
    this.setCounts();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.checklistItems && !changes.checklistItems.firstChange) {
      this.setCounts();
    }
  }

  private setCounts(): void {
    this.completeCount = this.utilitiesService.countMatching(this.checklistItems, item => this.checklistHelperService.isCompleted(item));
    this.incompleteCount = this.utilitiesService.countMatching(this.checklistItems, item => !this.checklistHelperService.isCompleted(item));
    this.failedOrPoorCount = this.utilitiesService.countMatching(this.checklistItems, item => this.checklistHelperService.isFailed(item));
    this.unsureOrFairCount = this.utilitiesService.countMatching(this.checklistItems, item => this.checklistHelperService.isUnsureOrFair(item));
    this.percentageComplete = this.completeCount / this.checklistItems.length * 100;
  }

  public toggleExpandOption() {
    this.toggleExpand.emit();
  }
}
